import {useStyles} from '../../../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../../../shared/theme/helpers';

export const GetMobileStyles = () =>
  useStyles(({theme}) => ({
    container: {
      borderColor: theme.color.borderColor,
      borderTopWidth: 1,
      borderStyle: 'solid',
    },
    icon: {
      height: 12,
      width: 12,
      color: theme.color.primaryColor,
    },
    item: {
      borderBottomWidth: 1,
      borderStyle: 'solid',
      borderColor: theme.color.borderColor,
      position: 'relative',
      paddingBottom: 24,
      paddingTop: 8,
    },
    itemContent: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    itemTextWrapper: {
      flex: 1,
      paddingBottom: 4,
      paddingLeft: 10,
    },
    itemText: {
      ...theme.fonts.bodySmallLight,
      color: theme.color.textColor,
    },
    itemTextNotRead: {
      ...theme.fonts.bodySmall,
      color: theme.color.textColor,
    },
    itemDateTimeWrapper: {
      height: 26,
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      textAlign: 'right',
    },
    itemDateTime: {
      textAlign: 'right',
      ...theme.fonts.label,
      color: theme.color.labelText,
    },
    requestId: {
      width: 40,
    },
  }));

const GetStyles = () =>
  useStyles(({theme, mediaOnly}) => {
    return {
      icon: {
        width: 12,
        height: 12,
        color: theme.color.primaryColor,
      },
      iconContainer: {
        marginRight: 10,
      },
      colBodyText: {
        ...theme.fonts.h5Light,
        color: theme.color.labelText,
        flexWrap: 'nowrap',
      },
      colBodyTextNotRead: {
        ...theme.fonts.h5,
        flexWrap: 'nowrap',
      },
      colBody: {
        minHeight: 64,
      },
      colStatus: {
        flexBasis: 92,
        alignItems: 'center',
        justifyContent: 'center',
      },
      colText: {
        marginRight: 20,
        flexBasis: 558,
        flexGrow: 1,
      },
      colRequestId: {
        width: 50,
      },
      colDate: {
        ...mediaOnly(DeviceSize.desktop, {flexBasis: 160, marginRight: 40}, {flexBasis: 120, marginRight: 20}),
        alignItems: 'center',
        justifyContent: 'center',
      },
      colTime: {
        flexBasis: 92,
        alignItems: 'center',
        justifyContent: 'center',
      },
    };
  });

export type Styles = ReturnType<typeof GetStyles>;

export default GetStyles;
